export default "__VITE_ASSET__D3Rw5Rc___"